module.exports = __webpack_public_path__ + "static/fonts/Nexa Light.12108809.otf";